const namespace = {
  title: "Similar neighborhoods",
  title_zipCode: "Similar zip codes",
  title_county: "Similar counties",
  description:
    "Discover similar locations to this neighborhood and see how they compare in terms of characteristics and amenities.",
  descriptionWithNeighborhood:
    "Discover similar locations to {{neighborhoodName}} and see how they compare in terms of characteristics and amenities.",
  noData: "Similar neighborhoods are not available for this location.",
  tags: {
    lessAffordable: "Less affordable",
    comparable: "Comparable",
    moreAffordable: "More affordable",
  },
  pagination: {
    previous: "Show less",
    next: "Show more",
  },
} as const;

export default namespace;
